import { TeamLeaguePlayerStatus } from '@/entities/TeamPlayerInfo';
import { z } from 'zod';

export const captainManagerDesignationSchema = z.object({
	role: z.nativeEnum(TeamLeaguePlayerStatus)
});
export type CaptainManagerDesignationData = z.infer<typeof captainManagerDesignationSchema>;
